import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Output, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { CoreVm, AddCoreVm, FileModelVM, AddContactVm, AddCompanyVm } from 'src/app/viewModels/core/core-vm';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { map, startWith } from 'rxjs/operators';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { Router } from '@angular/router';
import { AddTouchesComponent } from '../addtouches/addtouches.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfirmDialogChangeComponent } from '../reusableComponents/confirm-dialog-change/confirm-dialog-change.component';
import { PaycheckErrorComponent } from '../paycheckError/paycheckError.component';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})

export class DetailsComponent implements OnInit {

  addressFormGroup: any = [];
  cityValue: any;
  stateValue: any;
  zipValue: any;
  countryValue: any;
  addressValueField: any = Object;
  cityValueField: any = Object;
  stateValueField: any = Object;
  zipValueField: any = Object;
  arryaControlNameIdpare: any = [];
  arrayControlNameSubfolderID: any = [];
  emptyArrya: any = [];
  isTypeChanged: boolean = false;
  checkboxnames: any = [];
  tagvalues: string='';

  gModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
  };

  contactCoreListing: any=[];
  showPaycheck: boolean = false;
  @Output() SendtoSaved3C = new EventEmitter();
  @Input() aiDetails: any = [] = [];
  @Input() ViewOrUpdate: string = "";
  ProcessStageListForDropDown: any = [];
  ProcessStageIdDrp: number = 0;

  constructor(
    private formBuilder: FormBuilder, private statusConst: StatusConstant, private loaderService: LoaderService,
    private coreService: CoreService, private toastr: ToastrService, private settingService: SettingService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses, private constant: Constants,
    private _dataSharingService: DataSharingService, private coreVm: CoreVm, private addCoreVm: AddCoreVm, private addContactVm: AddContactVm,
    private addCompanyVm: AddCompanyVm, private fileModelVM: FileModelVM, private settingsService: SettingService, private router: Router,
    private dialog: MatDialog, private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList')|| '[]');
    offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  ImagePathURL: string = '';
  imageSrc: string='';
  FileName: any;
  FileExtention: any;
  Base64String: any;
  chkStatusArry: any;
  coreFieldList: any;
  checkBoxList: any = [];
  currentUser: any;
  transactionUserName: any;
  transactionUserRole: any;
  openDocumentDetail: boolean = false;
  showUserDetail: boolean = false;
  showContactList: boolean = false;
  showCreateTouches: boolean = false;
  showContactdetail: boolean = false;
  showShareFile: boolean = false;
  documentViewer: boolean = false;
  showCreateTask: boolean = false;
  showLinkPI: boolean = false;
  showTaskDetail: boolean = false;
  getFieldsListResponseHolder: any;
  fieldsList: any=[] = [];
  fieldListFolderWise: any=[] = [];
  dropdownlist: any;
  multipleDropdownList: any;
  radioButtonlist: any;
  getFieldModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
  };
  folderText = 'Task';
  dynamicArray: any;
  dynamicArrayEdit: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;

  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: false,
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  showTextBoxField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  clickEventsubscription: Subscription;
  coreUserList: any;
  responseHolder: any;
  //transactionID: number;
  databaseId: string;
  organizationId: string;
  myFormGroup: FormGroup;
  TypeList: any = [];
  step = 0;
  TypeListForDropDown: any = [];
  TypeIdDrp: any;
  CityModel = {
    Name: '',
    databaseID: 0,
    userID: ''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID: ''
  };
  zipOption: any=[];
  stateList: any=[];
  cityOption: string[] = [];
  getTagListResponseHolder: any;
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize: 0
  };
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[];
  allTags: string[] = [];

  moduleName: string='';
  contactVm = {
    DatabaseID: 0,
    OrganizationID: 0,
    UserID: '',
    PageIndex: 0,
    PageSize: 0,
    FolderId: 0,
    transactionID: 0,
    subFolderID: 0,
    searchKey: '',
    contactID: 0,
    myOfficeID: 0,
    officeID: 0,
    OfficeIDList: []
  }
  companyVm = {
    DatabaseID: 0,
    OrganizationID: 0,
    UserID: '',
    PageIndex: 0,
    PageSize: 0,
    FolderId: 0,
    transactionID: 0,
    subFolderID: 0,
    searchKey: '',
    companyID: 0,
    myOfficeID: 0,
    officeID: 0,
    OfficeIDList: []
  }
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @Output() closeDetail = new EventEmitter<boolean>();
  @Input() modulenames: string;
  @Input() transactionID: number;
  @Input() modulename: string;
  @Input() openFor: string="";
  folderList: any;
  folderID: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  @Output() selectedCoreIdForSendTaskListUpdate = new EventEmitter();
  @Input() SendingFor: string = "";
  stages: any = [] = [];
  selectedTabIndex = 0;
  entityId: number = 0;
  pendingPatientId: any;
  patientId: any;

  // fields that span both columns of the drawer's two-column form grid
  isWideField(f: any): boolean {
    return (f.fieldNames?.length > 0) || ['Textarea', 'Checkbox', 'Address', 'Image', 'URL'].includes(f.fieldTypeName)
      || f.fieldName == 'Tags';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];
    this.dynamicArrayAddressTemp = [];
    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.modulenames;
    this.transactionID;
    this.openFor;
    if(this.openFor=="note"){
      this.textLabel='Note';
      this.selectedTabIndex = 1; // Index starts at 0
      this.showActivityData();
    }else{
      this.selectedTabIndex = 0;
    }
    this.getAllTagsList();
    this.getStateDropdownList(231);
    this.getPDPMStageslist();

    if (this.modulenames == "Core") {
       //this.getThirdPartyApplicationList();
       //var paychecks = sessionStorage.getItem('Paycheck');
        var PointClickCare = sessionStorage.getItem('PointClickCare');
        // if(paychecks=="true"){
        //   this.ShowPaycheck=true;
        // }
        if (PointClickCare == "true") {
          this.ShowPointClickCare = true;
        }

        this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
        if (this.associatedAPIs.length > 0) {
          //var checkPayCheck = [];
          var checkPCC = [];

          // checkPayCheck = this.associatedAPIs.filter((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true);
          // if (checkPayCheck.length > 0) {
          //   this.showPaycheck = true;
          // } else {
          //   this.showPaycheck = false;
          // }

          checkPCC = this.associatedAPIs.filter((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
          if (checkPCC.length > 0) {
            this.showPCC = true;
          } else {
            this.showPCC = false;
          }
        }
      this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));
      var data = this.folderList.filter((x:any) => x.mainModuleName === 'Core');
      this.folderID = data[0].folderID;
      this.getCoreUserDetailsforSubFolderId();
      //this.getCoreUserDetails();
    }
    if (this.modulenames == "Contact") {
      this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));
      var data = this.folderList.filter((x:any) => x.mainModuleName === 'Contact');
      this.folderID = data[0].folderID;
      this.getContactUserDetailsforSubFolderId();
      //this.getContactUserDetails(); 
    }
    if (this.modulenames == "Company") {
      this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));
      var data = this.folderList.filter((x:any) => x.mainModuleName === 'Company');
      this.folderID = data[0].folderID;
      this.getCompanyUserDetailsforSubFolderId();
      // this.getCompanyUserDetails();
    }

  }

  ngOnInit(): void {
    // this.dynamicArray = [];
    // this.dynamicArrayPhone = [];
    // this.dynamicArrayAddress = [];
    // this.dynamicArrayWebsite = [];
    // this.dynamicArrayAddressTemp = [];   
    // let group = {};
    // this.myFormGroup = new FormGroup(group);   
    // this.getAllTagsList();   
    // this.getStateDropdownList(231);    
  }

  getAddressField(addressFieldsArray: any, type: number) {
    let field = addressFieldsArray.find(m => m.childFieldType == type);
    return field.fieldValue
  }

  closeListingDetails() {
    this.showPaycheck = false;
    if (this.SendingFor == "SendTasklist") {
      this.selectedCoreIdForSendTaskListUpdate.emit("Close");
      this.closeDetail.emit(false);
    } else {
      this.closeDetail.emit(false);
    }
    // this.closeDetail.emit(false);
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check = [];
    check = this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if (check.length > 0) {
      this.fruitCtrl.setValue(null);
      return;
    }
    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());

      if (index >= 0) {
        //this.fruits.splice(index, 1);
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
    this.myFormGroup.markAsDirty();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags = this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }


  getCompanyUserDetailsforSubFolderId() {
    this.coreUserList = [];
    this.companyVm.DatabaseID = Number(this.databaseId);
    this.companyVm.OrganizationID = Number(this.organizationId);
    this.companyVm.companyID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
    this.companyVm.FolderId = this.folderID;//19; 
    this.companyVm.UserID = this.currentUser.UID;
    this.companyVm.officeID = this.myOfficeID;
    this.companyVm.OfficeIDList = this.OfficeIDList;
    this.coreService.getCompanyUserDetails(this.companyVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          var TypeData = response.data.fields.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          if (TypeData.length > 0 && TypeData != undefined) {
            if (TypeData[0].fieldValue != "") {
              let id: string = TypeData[0].fieldValue.toString();
              this.TypeIdDrp = parseInt(id);
            }
            else {
              this.TypeIdDrp = "0";
            }
          }
          else {
            this.TypeIdDrp = "0";
          }
          this.getCompanyUserDetails();
        }
      }
    });
  }

  getContactUserDetailsforSubFolderId() {
    this.coreUserList = [];
    this.contactVm.DatabaseID = Number(this.databaseId);
    this.contactVm.OrganizationID = Number(this.organizationId);
    this.contactVm.contactID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
    this.contactVm.FolderId = this.folderID;
    this.contactVm.UserID = this.currentUser.UID;
    this.contactVm.officeID = this.myOfficeID;
    this.contactVm.OfficeIDList = this.OfficeIDList;
    this.coreService.getContactUserDetails(this.contactVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          var TypeData = response.data.fields.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          if (TypeData.length > 0 && TypeData != undefined) {
            if (TypeData[0].fieldValue != "") {
              let id: string = TypeData[0].fieldValue.toString();
              this.TypeIdDrp = parseInt(id);
            }
            else {
              this.TypeIdDrp = "0";
            }
          }
          else {
            this.TypeIdDrp = "0";
          }
          this.getContactUserDetails();
        }
      }
    });
  }

  getCoreUserDetailsforSubFolderId() {
    this.coreUserList = [];
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.coreID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
    this.coreVm.FolderId = this.folderID;
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var TypeData = response.data.fields.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          if (TypeData.length > 0 && TypeData != undefined) {
            if (TypeData[0].fieldValue != "") {
              let id: string = TypeData[0].fieldValue.toString();
              this.TypeIdDrp = parseInt(id);
            }
            else {
              this.TypeIdDrp = "0";
            }
          }
          else {
            this.TypeIdDrp = "0";
          }
          this.getCoreUserDetails();
        }
      }
    });
  }


  // get Tag List
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;
        }
        else {
        }
      }
    });
  }

  isChecked(fieldName, chk) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    if (_newcheckBoxlist[0].selectedCHK != '') {
      return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
    } else {
      return false;
    }
  }

  // OnChange($event: any, chk: any, fieldId: any) {
  //   this.myFormGroup.get(chk).markAsDirty();    
  //   if (!this.chkStatusArry) {
  //     this.chkStatusArry = [];
  //   }
  //   if ($event.checked) {
  //     this.chkStatusArry.push({
  //       ckh: chk,
  //       fieldId: fieldId,
  //     });
  //   } else {
  //     if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
  //       this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
  //     }
  //   }
  // }

  OnChange($event: any, chk: any, fieldId: any) {
    this.myFormGroup.get(chk).markAsDirty();
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {
      if (this.chkStatusArry.length > 0) {
        var checkRecord = [];
        checkRecord = this.chkStatusArry.filter((x:any) => x.fieldId == fieldId);
        if (checkRecord.length > 0) {
          this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = chk;
        }
      } else {
        this.chkStatusArry.push({
          ckh: chk,
          fieldId: fieldId,
        });
      }
    } else {
      if (this.chkStatusArry.length > 0) {
        this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = '';
      }
      // if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
      //   this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
      // }
    }
  }

  getddlSelectedVal(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '') {
        return _newdropdownlist[0].selectedVal;
      } else {
        return '';
      }
    }
  }

  getMultiddlSelectedVal(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '') {
        if (fieldName != "Tags") {
          return _newMuldropdownlist[0].selectedVal.split(',');
        } else {
          return _newMuldropdownlist[0].selectedVal;
        }
      } else {
        return '';
      }
    }
  }

  getCheckBoxlist(fieldName) {
    if (this.checkBoxList) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      if (_newcheckBoxlist[0]) {
        _newcheckBoxlist[0].value.forEach(v => {
          this.myFormGroup.addControl(v, this.formBuilder.control(''));
        });
        return _newcheckBoxlist[0].value;
      }
    }
  }

  getdropdownlist(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist.length > 0)
        return _newdropdownlist[0].value;
      else
        "";
    }
  }

  getMuldropdownlist(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist.length > 0)
        return _newMuldropdownlist[0].value;
      else
        "";
    }
  }


  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
    }
  }

  prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
      this.chkStatusArry = [];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(',');
        var selectedVal;
        let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

        if (chk.length > 0) {
          selectedVal = chk[0].fieldValue;
          selectedVal = selectedVal.replace(/,/g, '');
        }
        else {
          selectedVal = this.checkBoxList[i].fieldValue;
          selectedVal = selectedVal.replace(/,/g, '');
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }

        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };

        fieldcheckbox.push(FieldsCheckbox);

        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }

  // prepareCheckboxListForUI() {
  //   if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
  //     var fieldcheckbox = [];
  //     var value;
  //     if (!this.chkStatusArry) {
  //       this.chkStatusArry = [];
  //     }
  //     for (let i = 0; i < this.checkBoxList.length; i++) {       
  //       var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
  //       value = checkboxValue.split(','); 
  //       var selectedVal;
  //       let chk=this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

  //       if(chk.length>0){
  //         selectedVal=chk[0].fieldValue;
  //       }
  //        else{
  //        selectedVal=this.checkBoxList[i].fieldValue
  //       }  

  //       if(selectedVal==undefined || selectedVal==null){
  //         selectedVal="";
  //       }

  //       // if(chk.length==0){
  //       //   selectedVal="";
  //       // } 

  //       var FieldsCheckbox = {
  //         FieldValue: this.checkBoxList[i].fieldName,
  //         value: value,
  //         selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
  //       };

  //       fieldcheckbox.push(FieldsCheckbox);

  //       let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
  //       for (let n = 0; n < selectedCHKArray.length; n++) {
  //         this.chkStatusArry.push({
  //           ckh: selectedCHKArray[n],
  //           fieldId: this.checkBoxList[i].fieldID,
  //         });
  //       }
  //     }
  //     this.checkBoxList = fieldcheckbox;
  //   }
  // }

  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }

  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp = this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if (drp.length > 0) {
          selectedVal = drp[0].fieldValue;
        }
        else {
          selectedVal = this.multipleDropdownList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }

        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal: selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);

        var selectedValNew = "";

        if (this.multipleDropdownList[i].fieldName != "Tags") {
          selectedValNew = selectedVal.split(',');
          this.myFormGroup.get(this.multipleDropdownList[i].fieldName).setValue((selectedValNew));
        }

      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }

  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }
  statusType: string = "";
  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {

        if (this.dropdownlist[i].defaultValue.length > 0) {
          // var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          // value = drpValue.split(',');
          var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
          value = drpValue.split(',').map(item => item.trim());

          var selectedVal;
          let drp = this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
          if (drp.length > 0) {
            selectedVal = drp[0].fieldValue;
          }
          else {
            selectedVal = this.dropdownlist[i].fieldValue
          }

          if (selectedVal == undefined || selectedVal == null) {
            selectedVal = "";
          }

          if (this.dropdownlist[i].fieldName == "Status") {
            selectedVal = this.statusType;
          }

          // if(drp.length==0){
          //   selectedVal="";
          //  }

          var FieldsDrp = {
            FieldValue: this.dropdownlist[i].fieldName,
            value: value,
            selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
          };
          fieldListdrp.push(FieldsDrp);
        }
      }
      this.dropdownlist = fieldListdrp;
    }
  }

  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  appendEle(field: any, type: any, index: any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);
    let addressRefactor = field.address.filter(function (value, index) {
      return index != 3;
    });
    addressRefactor.splice(2, 0, field.address.find(x => x.childFieldType == 3));
    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address: addressRefactor
    };


    //1 Email ,2 Address,3 Phone,4 website
    if (type == 2) {
      this.myFormGroup.addControl('City' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + index, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + index);
      this.addressFormGroup.push('City' + index);
      this.addressFormGroup.push('State' + index);
      this.addressFormGroup.push('ZipCode' + index);
      this.addressFormGroup.push('Country' + index);
    }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);
  }

  addMore(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.addressValueField[fieldName + length] = '';
      this.cityValueField['City' + length] = '';
      this.stateValueField['State' + length] = '';
      this.zipValueField['ZipCode' + length] = ''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + length);
      this.addressFormGroup.push('City' + length);
      this.addressFormGroup.push('State' + length);
      this.addressFormGroup.push('ZipCode' + length);
      this.addressFormGroup.push('Country' + length);

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address: this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }

  getAddressTypeFieldName(childFieldType:any) {
    if (childFieldType == 3)
      return 'City';
    if (childFieldType == 2)
      return 'State';
    if (childFieldType == 4)
      return 'ZipCode';
    if (childFieldType == 1)
      return 'Country';
  }

  getCoreUserDetailsOnTypeChange(event: any, fieldName: any) {
    if (this.modulenames == "Core") {
      this.transactionID;
      this.isTypeChanged = true;
      this.TypeIdDrp = parseInt(event.value);
      this.arryaControlNameIdpare = []
      this.arrayControlNameSubfolderID = [];
      this.getCoreUserDetails();
    }
    if (this.modulenames == "Contact") {
      this.transactionID;
      this.isTypeChanged = true;
      this.TypeIdDrp = parseInt(event.value);
      this.arryaControlNameIdpare = []
      this.arrayControlNameSubfolderID = [];
      this.getContactUserDetails();
    }
    if (this.modulenames == "Company") {
      this.transactionID;
      this.isTypeChanged = true;
      this.TypeIdDrp = parseInt(event.value);
      this.arryaControlNameIdpare = []
      this.arrayControlNameSubfolderID = [];
      this.getCompanyUserDetails();
    }
  }


  getCoreUserDetails() {
    this.transactionID = this.transactionID;
    // this.coreUserList = [];
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.coreID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
    this.coreVm.FolderId = this.folderID;//17;
    this.coreVm.subFolderID = Number(this.TypeIdDrp);
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          // sessionStorage.setItem("PCCPatientID", response.data.patientId);
          // sessionStorage.setItem("PCCPendingPatientID", response.data.pendingPatientId);
          this.statusType = response.data.status;

          this.coreUserList = response.data.fields;

          this.entityId = response.data.coreID;
          this.pendingPatientId = response.data.pendingPatientId;
          this.patientId = response.data.patientId;
          if (this.pendingPatientId == null) {
            this.pccToolTip = "Send to PointClickCare";
          } else {
            this.pccToolTip = "Update to PointClickCare";
          }

          if (this.responseHolder.data.paychexID == null) {
            this.showPaycheck = false;
          } else {
            this.showPaycheck = true;
          }

          this.TypeListForDropDown = response.data.types;
          this.TypeListForDropDown.splice(0, 0, { folderName: "Select", isChecked: false, subFolderID: 0 });

          var TypeData = this.coreUserList.filter((e:any) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          this.ProcessStageListForDropDown = response.data.stages;
          this.ProcessStageIdDrp = response.data.processStageID;
          this.medicalCategoryID = response.data.medicalCategoryID;

          this.coreProcessStages = response.data.coreProcessStages;
          this.stages = response.data.stages;

          var taglist;
          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist != undefined) {
            this.tags = [];
            if (taglist[0].fieldValue != "") {
              this.tags = taglist[0].fieldValue.split(',');
            }
            else {
              this.tags = [];
            }
          }
          else {
            this.tags = [];
          }

          // var NewList;
          // NewList = response.data.fields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          // NewList.splice(1, 0, type[0]);
          // this.coreUserList = NewList;

          var NewListMedicalCategory;
          NewListMedicalCategory = response.data.fields.filter((s) => s.fieldName.toLowerCase() != 'pdpm category');
          var MedicalCategory: any = [] = [];
          MedicalCategory = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName.toLowerCase() == 'pdpm category');
          if (MedicalCategory.length > 0) {
            NewListMedicalCategory.splice(2, 0, MedicalCategory[0]);
            this.coreUserList = NewListMedicalCategory;
          }

          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          let multiNameArray :any= [];
          let ArrayWithGroupedElement :any= [];
          this.coreUserList = this.coreUserList.filter((s:any) => s.availableOn != 2);
          this.coreUserList = this.coreUserList.filter((s:any) => s.rolePermission != 2);

          this.coreUserList.forEach((formControl:any) => {
            if (this.ViewOrUpdate != "Update") {
              if (formControl.fieldTypeName == 'Date') {
                formControl.fieldValue = this.convertToUTCDateDetails(formControl.fieldValue);
              }
            }
            let count = multiNameArray.filter((x:any) => x.fieldID == formControl.fieldID).length;
            if (count == 0) {
              multiNameArray.push(formControl);
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });

              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac:any, i:any) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType),
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
            else if (count > 0) {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });
              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac:any, i:any) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType) + count,
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
          });


          this.coreUserList.forEach((formControl:any) => {
            let count = ArrayWithGroupedElement.filter((x:any) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0).length;
            let elements = this.coreUserList.filter((x:any) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0);
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter((x:any) => x.fieldName != 'Address');
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter((x:any) => x.fieldName != 'Email');
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter((x:any) => x.fieldName != 'Phone');
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter((x:any) => x.fieldName != 'Website');
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }

              ArrayWithGroupedElement.push(elements[0]);
            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });

          this.coreUserList = ArrayWithGroupedElement;

          const Fields = {};
          this.coreUserList.forEach((formControl:any) => {
            if (formControl.fieldName == 'Name') {
              this.transactionUserName = formControl.fieldValue;
            }
            if (formControl.fieldName == 'Type') {
              let type = this.TypeListForDropDown.find(x => x.subFolderID == formControl.fieldValue);
              this.transactionUserRole = (type != null || type != undefined) ? type.folderName : ""
            }
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find(
                (x) => x.fieldNameID == formControl.fieldNameID
              ); 0
              formControl.placeholderVal = plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            }

          });
          this.ImagePathURL = (response.data.imageUrl == null || response.data.imageUrl == undefined || response.data.imageUrl == '') ? '' : response.data.imageUrl;

          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();

          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');
          //
          ///
          ///fruitCtrl
          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          // this.coreVm.DatabaseID = Number(this.databaseId);
          // this.coreVm.OrganizationID = Number(this.organizationId);
          // this.coreVm.UserID = this.currentUser.UID;
          // this.coreVm.FolderId = this.folderID;
          var reqModel = {
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            folderID: this.folderID,//17;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID: this.myOfficeID,
            OfficeIDList: this.OfficeIDList
          }
          this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList = response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;
            // Modified array containing group starts
            tempArryacoreFieldList.forEach(element => {
              if (element.data.length > 1) {
                var indexArray = [];

                element.data.forEach(elementin => {
                  if (elementin.fieldID > 0) {
                    let grpele = this.coreUserList.find(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                    elementin.id = grpele != undefined ? grpele.id : 0;
                    elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                    if (elementin.fieldNames.length > 0) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;

                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)) {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreUserList.findIndex(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    indexArray.push(index);
                  }
                });

                this.coreUserList = this.coreUserList.filter(function (value, index) {
                  return indexArray.indexOf(index) == -1;
                });
                this.coreUserList.splice(indexArray[0], 0, element);

              }
            });


            ArrayWithGroupedElement.forEach(element => {
              if (element.fieldName == "Address") {
                if (element.address.length > 0) {
                  if (element.address.find(m => m.childFieldType == 3) != undefined)
                    this.cityValue = element.address.find(m => m.childFieldType == 3).fieldValue;
                  else
                    this.cityValue = "";
                  if (element.address.find(m => m.childFieldType == 2) != undefined)
                    this.stateValue = element.address.find(m => m.childFieldType == 2).fieldValue;
                  else
                    this.stateValue = "";
                  if (element.address.find(m => m.childFieldType == 4) != undefined)
                    this.zipValue = element.address.find(m => m.childFieldType == 4).fieldValue;
                  else
                    this.zipValue = "";
                }
              }
            });


            this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
            this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
            this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

            var data = [];

            data = this.coreUserList.filter((s) => s.fieldID == 0);

            if (data.length > 0) {
              for (var i = 0, len = data.length; i < len; ++i) {
                var DrpData = [];
                DrpData = data[i].data.filter((s) => s.fieldTypeName == 'Dropdown');
                if (DrpData.length > 0) {
                  for (var v = 0, char = DrpData.length; v < char; ++v) {
                    this.dropdownlist.push(DrpData[v]);
                  }
                }

                var MultiData = [];
                MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
                if (MultiData.length > 0) {
                  for (var v = 0, char = MultiData.length; v < char; ++v) {
                    this.multipleDropdownList.push(MultiData[v]);
                  }
                }

                var CheckboxData = [];
                CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
                if (CheckboxData.length > 0) {
                  for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                    this.checkBoxList.push(CheckboxData[v]);
                  }
                }
              }
            }

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                //var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                //value = drpValue.split(',');
                var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
                value = drpValue.split(',').map(item => item.trim());

                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }


            // Modified array containing group ends 
            this.fillCheckBoxList();
            this.prepareCheckboxListForUI();

            this.fillDropDown();
            this.prepareDropDownForUI();

            this.fillMultiDropDown();
            this.prepareMultiDropDownForUI();
          });

          this.dynamicArray = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayWebsite = [];
          this.dynamicArrayTemp.forEach((e, i) => {
            this.appendEle(e, 1, i + 1);
          });
          this.dynamicArrayAddressTemp.forEach((e, i) => {
            this.appendEle(e, 2, i + 1);
          });
          this.dynamicArrayPhoneTemp.forEach((e, i) => {
            this.appendEle(e, 3, i + 1);
          });
          if (this.dynamicArrayWebsiteTemp != undefined)
            this.dynamicArrayWebsiteTemp.forEach((e, i) => {
              this.appendEle(e, 4, i + 1);
            });
          this.loaderService.hide();
          if (this.isTypeChanged) {
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged = false;
          }
        } else {
          this.coreUserList = [];
        }
        
        if (this.ViewOrUpdate == "Update") {
          if (this.aiDetails.length > 0) {

          this.aiDetails.forEach((item: any) => {
           const value = item.value?.toString().trim();
           if ((item.fieldName === 'SSN' && value === '000-00-0000') ||
             value === 'Not Available' ||  value === '') 
              {
               item.value = '';
             }
          });

            this.isCoreUserListReady = false;
            this.loaderService.show();
            this.coreUserList.forEach((formControl:any) => {
              let fieldValueDetails = [];

              if (formControl.fieldID === 0) {
                const groupFields = formControl.data.filter((x:any) => x.fieldID > 0);
                if (groupFields.length > 0) {
                  groupFields.forEach((groupField:any) => {
                    // const fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldID === groupField.fieldID);
                    //const fieldValueDetails = this.aiDetails.filter((x:any) => (x.fieldName || x.formFieldName) === groupField.fieldName);
                    const fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldName === groupField.fieldName ||
                      (x.formFieldName != null && x.formFieldName !== '' && x.formFieldName === groupField.fieldName));

                    if (fieldValueDetails.length > 0) {
                      this.setFieldValue(groupField, fieldValueDetails[0]);
                    }
                  });
                }
              } else {

                // fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldID === formControl.fieldID);
                // fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldName || x.formFieldName === formControl.fieldName);
                fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldName === formControl.fieldName ||
                  (x.formFieldName != null && x.formFieldName !== '' && x.formFieldName === formControl.fieldName));

                if (fieldValueDetails.length > 0) {
                  this.setFieldValue(formControl, fieldValueDetails[0]);
                }
              }
              //  this.coreUserList;
              //  this.cdr.detectChanges();
            });
            // this.coreUserList;
            // this.cdr.detectChanges();
          }
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  isCoreUserListReady = true;

  // setFieldValue(formControl, fieldValueDetail) {
  //   if (formControl.fieldTypeName === 'Date') {
  //     formControl.fieldValue = this.convertToUTCDate(fieldValueDetail.value);
  //   } else {
  //     if(formControl.fieldName === 'Address'){
  //       if(fieldValueDetail.value!=""){
  //         this.runAIButton_4o_onGivenContext(fieldValueDetail.value,formControl);
  //       }     
  //     }else{
  //       formControl.fieldValue = fieldValueDetail.value;
  //     }      
  //   }
  // }

  setFieldValue(formControl:any, fieldValueDetail:any) {
    if (formControl.fieldTypeName === 'Date') {
      formControl.fieldValue = this.convertToUTCDate(fieldValueDetail.value);
    } else if (formControl.fieldTypeName === 'Dropdown') {
      if (formControl.fieldName.toLowerCase() == "sex".toLowerCase() || formControl.fieldName.toLowerCase() == "gender".toLowerCase()) {
      if (fieldValueDetail?.value) {
          const val = fieldValueDetail.value.toLowerCase();

          if (val === 'm' || val === 'ma' || val === 'mal') {
            fieldValueDetail.value = "Male";
          }

          if (val === 'f' || val === 'fe' || val === 'fem' || val === 'fema' || val === 'femal') {
            fieldValueDetail.value = "Female";
          }
        }
        // if (fieldValueDetail.value.toLowerCase() == 'm'.toLowerCase() || fieldValueDetail.value.toLowerCase() == 'ma'.toLowerCase() || fieldValueDetail.value.toLowerCase() == 'mal'.toLowerCase()) {
        //   fieldValueDetail.value = "Male";
        // }
        // if (fieldValueDetail.value.toLowerCase() == 'f'.toLowerCase() || fieldValueDetail.value.toLowerCase() == 'fe'.toLowerCase() || fieldValueDetail.value.toLowerCase() == 'fem'.toLowerCase() || fieldValueDetail.value.toLowerCase() == 'fema'.toLowerCase() || fieldValueDetail.value.toLowerCase() == 'femal'.toLowerCase()) {
        //   fieldValueDetail.value = "Female";
        // }
      }
      formControl.fieldValue = this.DropdownSetValue(formControl, fieldValueDetail);
    } else {
      if (formControl.fieldName === 'Address') {
        if (fieldValueDetail.value !== "") {
          this.runAIButton_4o_onGivenContext(fieldValueDetail.value, formControl);
        }
      } else {
        formControl.fieldValue = fieldValueDetail.value;
      }
    }
  }

  DropdownSetValue(formControl:any, fieldValueDetail:any) {
    const defaultValue = formControl?.defaultValue ?? '';

    //formControl.defaultValue= formControl.defaultValue?.trim().replace(/\s*,\s*/g, ',');

    // Ensure it's a string and split it
    const separatedArray: string[] = defaultValue
      .split(',')
      .map(item => item.trim())
      .filter(item => item !== ''); // Optional: remove empty items

    // Perform case-insensitive comparison
    const match = separatedArray.find(item => item.trim().toLowerCase() === fieldValueDetail?.value?.trim().toLowerCase());

    return match ?? '';
  }

  // setFieldValue(formControl, fieldValueDetail) {
  //   if (formControl.fieldTypeName === 'Date') {     
  //     formControl.fieldValue = this.convertToUTCDate(fieldValueDetail.value);
  //   } else {     
  //     formControl.fieldValue = fieldValueDetail.value;
  //   }
  // }  

  convertToUTCDateDetails(dateString: string): Date | string {

    if (!dateString) return '';

    // Split the date and time parts by 'T'
    const [datePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number)
    const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
    //let newUTCDate=this.formatAsUTC(date); 
    return date;
  }

  convertToUTCDate(dateString: string): Date | string {
    if (!dateString) return '';

    // Split the date and time parts by 'T'
    const [datePart] = dateString.split('T');
    const [month, day, year] = datePart.split('/').map(Number)
    //const [year, month, day] = datePart.split('/').map(Number)
    const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
    //let newUTCDate=this.formatAsUTC(date); 
    if (isNaN(date.getTime())) {
      if (!dateString) return '';
    } else {
      return date;
    }
  }

  addressLine: string = "";

  runAIButton_4o_onGivenContext(addressValue:any, formControl:any) {
    let instructionString = `Given a single text containing a US address, extract and return the following fields as a JSON object:  
            \addressLine1\ (first line of the address)  
            \city\ (city name)  
            \state\ (must be converted to its 2-letter abbreviation from the provided list, case-insensitive)  
            \zipcode\ (5-digit or 5+4 ZIP code)  
  
           **Rules:**  
            The \state\ must strictly match one of these abbreviations (case-insensitive):  
            \AL, AK, AZ, AR, CA, CO, CT, DE, DC, FL, GA, HI, ID, IL, IN, IA, KS, KY, LA, ME, MD, MA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NY, NC, ND, OH, OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WA, WV, WI, WY\  
            If the state is given as a full name (e.g., "California"), convert it to its abbreviation ("CA").  
            If no valid state is found, set \state\ to \null\.  
            If any field cannot be extracted, set it to \null\.  
            Return **only the JSON object** with no additional text or explanations.  
  
            **Example Input:**  
              "123 Main St, Los Angeles, California 90001"  
  
            **Expected Output:**  
             {"addressLine1": "123 Main St", "city": "Los Angeles", "state": "CA", "zipcode": "90001"}  
  
             Now process this ADDRESS input: ${addressValue}`;


    this.coreService.submit_prompt_4o_onGivenContext_New({ prompt: instructionString }).subscribe(response => {
      if (response && response.status == this.statusConst.statusSuccess) {
        //response.data  =  response.data.filter((x) => x.abbreviation != null);
        // Extract JSON from AI's response (handling edge cases)
        let jsonStringNew = response.data;
        let jsonStart = jsonStringNew.indexOf('{');
        let jsonEnd = jsonStringNew.lastIndexOf('}') + 1;
        let jsonString = jsonStringNew.slice(jsonStart, jsonEnd);
        let addressObj = JSON.parse(jsonString);
        //To do logic to map core fields        
        if (addressObj.addressLine1 != null) {
          formControl.fieldValue = addressObj.addressLine1;
          this.addressLine = addressObj.addressLine1;
        }
        if (addressObj.city != null) {
          this.cityValue = addressObj.city;
        }
        if (addressObj.state != null) {
          this.stateValue = addressObj.state;
        }
        if (addressObj.zipcode != null) {
          // this.zipValue=addressObj.zipcode;
          const zip = addressObj.zipcode?.toString().match(/^\d{1,5}/);//addressObj.zipcode?.toString().match(/^\d{5}/);
          this.zipValue = zip ? zip[0] : "";
        }

        this.coreUserList.forEach(field => {
          if (field.fieldID === 0 && Array.isArray(field.data)) {
            // 🔹 Case 1: Inside group fields
            const addressField = field.data.find(item => item.fieldName === 'Address');
            if (addressField) {
              addressField.fieldValue = this.addressLine;
            }
          } else {
            // 🔹 Case 2: Top-level fields
            if (field.fieldName === 'Address') {
              field.fieldValue = this.addressLine;
            }
          }
        });
        this.loaderService.hide();
        this.isCoreUserListReady = true;
        this.cdr.detectChanges();

      } else {

      }
    },
      error => {

      }
    );
  }

  // setFieldValue(formControl, fieldValueDetail) {
  //   if (formControl.fieldTypeName === 'Date'){

  //   }else{
  //     if(fieldValueDetail.value==""){
  //       formControl.fieldValue=formControl.fieldValue;
  //     }else{
  //       formControl.fieldValue = fieldValueDetail.value;
  //     }
  //   }

  //   // if (formControl.fieldTypeName === 'Date') {
  //   //   //formControl.fieldValue = this.convertToUTCDate(fieldValueDetail.value);
  //   // } else {
  //   //   formControl.fieldValue = fieldValueDetail.value;
  //   // }
  // }

  getCompanyUserDetails() {
    this.transactionID = this.transactionID;
    //this.coreUserList = [];
    this.companyVm.DatabaseID = Number(this.databaseId);
    this.companyVm.OrganizationID = Number(this.organizationId);
    this.companyVm.companyID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
    this.companyVm.FolderId = this.folderID;//19;
    this.companyVm.subFolderID = Number(this.TypeIdDrp);
    this.companyVm.UserID = this.currentUser.UID;
    this.companyVm.officeID = this.myOfficeID;
    this.companyVm.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.coreService.getCompanyUserDetails(this.companyVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreUserList = response.data.fields;
          this.statusType = response.data.status;
          if (this.responseHolder.data.paychexID == null) {
            this.showPaycheck = false;
          } else {
            this.showPaycheck = true;
          }

          this.TypeListForDropDown = response.data.types;
          this.TypeListForDropDown.splice(0, 0, {
            folderName: "Select",
            isChecked: false,
            subFolderID: 0
          });

          var TypeData = this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          var taglist;

          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist != undefined) {
            this.tags = [];
            if (taglist[0].fieldValue != "") {
              this.tags = taglist[0].fieldValue.split(',');
            }
            else {
              this.tags = [];
            }
          }
          else {
            this.tags = [];
          }

          // var NewList;
          // NewList = response.data.fields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
          // NewList.splice(1, 0, type[0]);
          // this.coreUserList = NewList;

          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          let multiNameArray :any= [];
          let ArrayWithGroupedElement :any= [];
          this.coreUserList.forEach((formControl:any) => {
            let count = multiNameArray.filter((x:any) => x.fieldID == formControl.fieldID).length;
            if (count == 0) {
              multiNameArray.push(formControl);
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });

              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac:any, i:any) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType),
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
            else if (count > 0) {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;

              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });
              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType) + count,
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
          });


          this.coreUserList.forEach((formControl) => {
            let count = ArrayWithGroupedElement.filter(
              (x) =>
                x.fieldID == formControl.fieldID &&
                formControl.fieldNames.length > 0
            ).length;
            let elements = this.coreUserList.filter(
              (x) =>
                x.fieldID == formControl.fieldID &&
                formControl.fieldNames.length > 0
            );
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Address'
                );
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Email'
                );
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Phone'
                );
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Website'
                );
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }

              ArrayWithGroupedElement.push(elements[0]);

            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });
          this.coreUserList = ArrayWithGroupedElement;

          const Fields = {};
          this.coreUserList.forEach((formControl:any) => {
            if (formControl.fieldName == 'Name') {
              this.transactionUserName = formControl.fieldValue;
            }
            if (formControl.fieldName == 'Type') {
              let type = this.TypeListForDropDown.find(x => x.subFolderID == formControl.fieldValue);
              this.transactionUserRole = (type != null || type != undefined) ? type.folderName : ""
            }
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find(
                (x) => x.fieldNameID == formControl.fieldNameID
              ); 0
              formControl.placeholderVal = plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            }

          });
          this.ImagePathURL = (response.data.imageUrl == null || response.data.imageUrl == undefined || response.data.imageUrl == '') ? '' : response.data.imageUrl;

          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');
          //
          ///
          ///fruitCtrl
          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          var reqModel = {
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            folderID: this.folderID,//19;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID: this.myOfficeID,
            OfficeIDList: this.OfficeIDList
          }
          this.coreService.getCompanyFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList = response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;
            // Modified array containing group starts
            tempArryacoreFieldList.forEach(element => {
              if (element.data.length > 1) {
                var indexArray = [];

                element.data.forEach(elementin => {
                  if (elementin.fieldID > 0) {
                    let grpele = this.coreUserList.find(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                    elementin.id = grpele != undefined ? grpele.id : 0;
                    elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                    if (elementin.fieldNames.length > 0) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)) {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreUserList.findIndex(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    indexArray.push(index);
                  }
                });

                this.coreUserList = this.coreUserList.filter(function (value, index) {
                  return indexArray.indexOf(index) == -1;
                });
                this.coreUserList.splice(indexArray[0], 0, element);

              }
            });
            ArrayWithGroupedElement.forEach(element => {
              if (element.fieldName == "Address") {
                if (element.address.length > 0) {
                  if (element.address.find(m => m.childFieldType == 3) != undefined)
                    this.cityValue = element.address.find(m => m.childFieldType == 3).fieldValue;
                  else
                    this.cityValue = "";
                  if (element.address.find(m => m.childFieldType == 2) != undefined)
                    this.stateValue = element.address.find(m => m.childFieldType == 2).fieldValue;
                  else
                    this.stateValue = "";
                  if (element.address.find(m => m.childFieldType == 4) != undefined)
                    this.zipValue = element.address.find(m => m.childFieldType == 4).fieldValue;
                  else
                    this.zipValue = "";
                }
              }
            });

            this.dropdownlist = this.coreFieldList.filter((s:any) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
            this.multipleDropdownList = this.coreFieldList.filter((s:any) => s.fieldTypeName == 'MultiSelect');
            this.checkBoxList = this.coreFieldList.filter((s:any) => s.fieldTypeName == 'Checkbox');

            var data = [];

            data = this.coreUserList.filter((s:any) => s.fieldID == 0);

            if (data.length > 0) {
              for (var i = 0, len = data.length; i < len; ++i) {
                var DrpData = [];
                DrpData = data[i].data.filter((s:any) => s.fieldTypeName == 'Dropdown');
                if (DrpData.length > 0) {
                  for (var v = 0, char = DrpData.length; v < char; ++v) {
                    this.dropdownlist.push(DrpData[v]);
                  }
                }

                var MultiData = [];
                MultiData = data[i].data.filter((s:any) => s.fieldTypeName == 'MultiSelect');
                if (MultiData.length > 0) {
                  for (var v = 0, char = MultiData.length; v < char; ++v) {
                    this.multipleDropdownList.push(MultiData[v]);
                  }
                }

                var CheckboxData = [];
                CheckboxData = data[i].data.filter((s:any) => s.fieldTypeName == 'Checkbox');
                if (CheckboxData.length > 0) {
                  for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                    this.checkBoxList.push(CheckboxData[v]);
                  }
                }
              }
            }

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                //  var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                // value = drpValue.split(',');
                var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
                value = drpValue.split(',').map(item => item.trim());

                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }


            // Modified array containing group ends 
            this.fillCheckBoxList();
            this.prepareCheckboxListForUI();

            this.fillDropDown();
            this.prepareDropDownForUI();

            this.fillMultiDropDown();
            this.prepareMultiDropDownForUI();
          });
          this.dynamicArray = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayWebsite = [];
          this.dynamicArrayTemp.forEach((e, i) => {
            this.appendEle(e, 1, i + 1);
          });
          this.dynamicArrayAddressTemp.forEach((e, i) => {
            this.appendEle(e, 2, i + 1);
          });
          this.dynamicArrayPhoneTemp.forEach((e, i) => {
            this.appendEle(e, 3, i + 1);
          });
          if (this.dynamicArrayWebsiteTemp != undefined)
            this.dynamicArrayWebsiteTemp.forEach((e, i) => {
              this.appendEle(e, 4, i + 1);
            });
          this.loaderService.hide();
          if (this.isTypeChanged) {
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged = false;
          }
          if (this.aiDetails.length > 0) {
            this.coreUserList.forEach((formControl:any) => {
              let fieldValueDetails = [];

              if (formControl.fieldID === 0) {
                const groupFields = formControl.data.filter((x:any) => x.fieldID > 0);
                if (groupFields.length > 0) {
                  groupFields.forEach((groupField:any) => {
                    const fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldID === groupField.fieldID);
                    if (fieldValueDetails.length > 0) {
                      this.setFieldValue(groupField, fieldValueDetails[0]);
                    }
                  });
                }
              } else {

                fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldID === formControl.fieldID);

                if (fieldValueDetails.length > 0) {
                  this.setFieldValue(formControl, fieldValueDetails[0]);
                }
              }
            });
          }
        } else {
          this.coreUserList = [];
        }
      }
    });
  }

  getContactUserDetails() {
    this.transactionID = this.transactionID;
    //this.coreUserList = [];
    this.contactVm.DatabaseID = Number(this.databaseId);
    this.contactVm.OrganizationID = Number(this.organizationId);
    this.contactVm.contactID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
    this.contactVm.FolderId = this.folderID;
    this.contactVm.subFolderID = Number(this.TypeIdDrp);
    this.contactVm.UserID = this.currentUser.UID;
    this.contactVm.officeID = this.myOfficeID;
    this.contactVm.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.coreService.getContactUserDetails(this.contactVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreUserList = response.data.fields;
          this.statusType = response.data.status;
          if (this.responseHolder.data.paychexID == null) {
            this.showPaycheck = false;
          } else {
            this.showPaycheck = true;
          }

          this.TypeListForDropDown = response.data.types;
          this.TypeListForDropDown.splice(0, 0, {
            folderName: "Select",
            isChecked: false,
            subFolderID: 0
          });

          var TypeData = this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          var taglist;

          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist != undefined) {
            this.tags = [];
            if (taglist[0].fieldValue != "") {
              this.tags = taglist[0].fieldValue.split(',');
            }
            else {
              this.tags = [];
            }
          }
          else {
            this.tags = [];
          }

          // var NewList;
          // NewList = response.data.fields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          // NewList.splice(1, 0, type[0]);
          // this.coreUserList = NewList;

          this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2);
          this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);
          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          let multiNameArray :any= [];
          let ArrayWithGroupedElement :any= [];

          this.coreUserList.forEach((formControl:any) => {
            let count = multiNameArray.filter((x:any) => x.fieldID == formControl.fieldID).length;
            if (count == 0) {
              multiNameArray.push(formControl);
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });

              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac:any, i:any) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType),
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
            else if (count > 0) {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;

              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });
              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType) + count,
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
          });


          this.coreUserList.forEach((formControl) => {
            let count = ArrayWithGroupedElement.filter(
              (x) =>
                x.fieldID == formControl.fieldID &&
                formControl.fieldNames.length > 0
            ).length;
            let elements = this.coreUserList.filter(
              (x) =>
                x.fieldID == formControl.fieldID &&
                formControl.fieldNames.length > 0
            );
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Address'
                );
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Email'
                );
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Phone'
                );
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter(
                  (x) => x.fieldName != 'Website'
                );
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }

              ArrayWithGroupedElement.push(elements[0]);

            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });
          this.coreUserList = ArrayWithGroupedElement;

          const Fields = {};
          this.coreUserList.forEach((formControl) => {
            if (formControl.fieldName == 'Name') {
              this.transactionUserName = formControl.fieldValue;
            }
            if (formControl.fieldName == 'Type') {
              let type = this.TypeListForDropDown.find(x => x.subFolderID == formControl.fieldValue);
              this.transactionUserRole = (type != null || type != undefined) ? type.folderName : ""
            }
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find(
                (x) => x.fieldNameID == formControl.fieldNameID
              ); 0
              formControl.placeholderVal = plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            }

          });
          this.ImagePathURL = (response.data.imageUrl == null || response.data.imageUrl == undefined || response.data.imageUrl == '') ? '' : response.data.imageUrl;

          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');
          //
          ///
          ///fruitCtrl
          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          var reqModel = {
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            folderID: this.folderID,//19;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID: this.myOfficeID,
            OfficeIDList: this.OfficeIDList
          }
          this.coreService.getContactFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList = response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;
            // Modified array containing group starts
            tempArryacoreFieldList.forEach(element => {
              if (element.data.length > 1) {
                var indexArray = [];

                element.data.forEach(elementin => {
                  if (elementin.fieldID > 0) {
                    let grpele = this.coreUserList.find(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                    elementin.id = grpele != undefined ? grpele.id : 0;
                    elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                    if (elementin.fieldNames.length > 0) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)) {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreUserList.findIndex(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    indexArray.push(index);
                  }
                });

                this.coreUserList = this.coreUserList.filter(function (value, index) {
                  return indexArray.indexOf(index) == -1;
                });
                this.coreUserList.splice(indexArray[0], 0, element);

              }
            });
            ArrayWithGroupedElement.forEach(element => {
              if (element.fieldName == "Address") {
                if (element.address.length > 0) {
                  if (element.address.find(m => m.childFieldType == 3) != undefined)
                    this.cityValue = element.address.find(m => m.childFieldType == 3).fieldValue;
                  else
                    this.cityValue = "";
                  if (element.address.find(m => m.childFieldType == 2) != undefined)
                    this.stateValue = element.address.find(m => m.childFieldType == 2).fieldValue;
                  else
                    this.stateValue = "";
                  if (element.address.find(m => m.childFieldType == 4) != undefined)
                    this.zipValue = element.address.find(m => m.childFieldType == 4).fieldValue;
                  else
                    this.zipValue = "";
                }
              }
            });


            this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
            this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
            this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

            var data = [];

            data = this.coreUserList.filter((s) => s.fieldID == 0);

            if (data.length > 0) {
              for (var i = 0, len = data.length; i < len; ++i) {
                var DrpData = [];
                DrpData = data[i].data.filter((s) => s.fieldTypeName == 'Dropdown');
                if (DrpData.length > 0) {
                  for (var v = 0, char = DrpData.length; v < char; ++v) {
                    this.dropdownlist.push(DrpData[v]);
                  }
                }

                var MultiData = [];
                MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
                if (MultiData.length > 0) {
                  for (var v = 0, char = MultiData.length; v < char; ++v) {
                    this.multipleDropdownList.push(MultiData[v]);
                  }
                }

                var CheckboxData = [];
                CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
                if (CheckboxData.length > 0) {
                  for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                    this.checkBoxList.push(CheckboxData[v]);
                  }
                }
              }
            }

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                // var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                // value = drpValue.split(',');
                var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
                value = drpValue.split(',').map(item => item.trim());

                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }

            // Modified array containing group ends 
            this.fillCheckBoxList();
            this.prepareCheckboxListForUI();

            this.fillDropDown();
            this.prepareDropDownForUI();

            this.fillMultiDropDown();
            this.prepareMultiDropDownForUI();
          });
          this.dynamicArray = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayWebsite = [];
          this.dynamicArrayTemp.forEach((e, i) => {
            this.appendEle(e, 1, i + 1);
          });
          this.dynamicArrayAddressTemp.forEach((e, i) => {
            this.appendEle(e, 2, i + 1);
          });
          this.dynamicArrayPhoneTemp.forEach((e, i) => {
            this.appendEle(e, 3, i + 1);
          });
          if (this.dynamicArrayWebsiteTemp != undefined)
            this.dynamicArrayWebsiteTemp.forEach((e, i) => {
              this.appendEle(e, 4, i + 1);
            });
          this.loaderService.hide();
          if (this.isTypeChanged) {
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged = false;
          }
          if (this.aiDetails.length > 0) {
            this.coreUserList.forEach((formControl) => {
              let fieldValueDetails = [];

              if (formControl.fieldID === 0) {
                const groupFields = formControl.data.filter((x:any) => x.fieldID > 0);
                if (groupFields.length > 0) {
                  groupFields.forEach((groupField) => {
                    const fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldID === groupField.fieldID);
                    if (fieldValueDetails.length > 0) {
                      this.setFieldValue(groupField, fieldValueDetails[0]);
                    }
                  });
                }
              } else {

                fieldValueDetails = this.aiDetails.filter((x:any) => x.fieldID === formControl.fieldID);

                if (fieldValueDetails.length > 0) {
                  this.setFieldValue(formControl, fieldValueDetails[0]);
                }
              }
            });
          }
        } else {
          this.coreUserList = [];
        }
      }
    });
  }


  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConst.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x) => x.abbreviation != null);
              response.data.forEach(e => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach(e => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }

  searchZip(zip: any) {
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.zipOption = [];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name: any) {
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.cityOption = [];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }


  getSubFolderFields(event, fieldName) {
    if (event != undefined && fieldName == "Type") {
      this.TypeIdDrp = event.value;
    }
  }

  getShortName(fullName) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var name = filename.split('.');
    this.FileName = name[0];
    this.FileExtention = '.' + name[1];
    this.myFormGroup.markAsDirty();
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;

    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImagePathURL = response.data;
        }
      }
    });
  }


  SaveCoreUserDetails(formValues: any) {
    if (this.modulenames == "Core") {
      this.saveCoreDetails(formValues);
      //this.closeListingDetails();
    }
    if (this.modulenames == "Contact") {
      this.saveContactDetails(formValues);
      this.closeListingDetails();
    }
    if (this.modulenames == "Company") {
      this.saveCompanyDetails(formValues);
      this.closeListingDetails();
    }
  }

  spinner: boolean = false;

  saveCoreDetails(formValues) {
    this.spinner = true;
    this.myFormGroup.markAsPristine();
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.CoreID = this.transactionID;
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) => key.includes(m.fieldName));

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }

        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
              var selectedValueChk = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();

            } else {
              selectedValues = '';
            }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');

              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          let ctrlsfi = this.arrayControlNameSubfolderID.find(e => e.name == key);
          let localDateOnly = "";

          if (tempList[0].fieldTypeName == 'Date') {
            let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;

            // If selectedDate is a string, set localDateOnly to the string value directly
            if (typeof selectedDate === "string") {
              localDateOnly = selectedDate;
            } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
              // Adjust the date to remove time and prevent timezone shift
              localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]; // Returns 'yyyy-MM-dd'
              formValues[key] = localDateOnly;
            } else {
              localDateOnly = ""; // Set to empty if no valid date
            }

          }

          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: ctrlsfi != undefined ? ctrlsfi.subfolderID : 0,
            ChildFields: [],
            id: frmctrl != undefined ? frmctrl.id : 0
          });
        }
      }



      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'City') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'City').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'State') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'State').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'ZipCode') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'ZipCode').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'Country') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'Country').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'City').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["City"],
      //   "childFieldType": 3
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'State').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["State"],
      //   "childFieldType": 2
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'ZipCode').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["ZipCode"],
      //   "childFieldType": 4
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'Country').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["Country"],
      //   "childFieldType": 1
      // })
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/


      //
      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let cityctrl = this.arryaControlNameIdpare.find(e => e.name == 'City' + i);
        let statectrl = this.arryaControlNameIdpare.find(e => e.name == 'State' + i);
        let zipcodectrl = this.arryaControlNameIdpare.find(e => e.name == 'ZipCode' + i);
        let countryctrl = this.arryaControlNameIdpare.find(e => e.name == 'Country' + i);
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        if (AddressDynamic != undefined) {
          AddressDynamic.ChildFields.push({
            "id": cityctrl != undefined ? cityctrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["City" + i],
            "childFieldType": 3
          })
          AddressDynamic.ChildFields.push({
            "id": statectrl != undefined ? statectrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["State" + i],
            "childFieldType": 2
          })
          AddressDynamic.ChildFields.push({
            "id": zipcodectrl != undefined ? zipcodectrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["ZipCode" + i],
            "childFieldType": 4
          })
          AddressDynamic.ChildFields.push({
            "id": countryctrl != undefined ? countryctrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["Country" + i],
            "childFieldType": 1
          })

          fieldList = fieldList.filter(function (value, index) {
            return index != indexDynamic;
          });
          fieldList.splice(indexDynamic, 0, AddressDynamic);
        }
      });
      //********** */
      fieldList = fieldList.filter((x:any) => x.FieldName != "Status");

      fieldList.forEach(f => {
        if (f.FieldValue === undefined) {
          f.FieldValue = "";
        }
      });

      fieldList.forEach(field => {
        if (field.ChildFields && field.ChildFields.length > 0) {
          field.ChildFields.forEach(child => {
            if (child.fieldValue === "") {
              child.fieldValue = null;
            }
          });
        }
      });

      this.addCoreVm.ImageUrl = this.ImagePathURL
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.TypeID = Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0;
      this.addCoreVm.Tags = this.tagvalues;
      this.addCoreVm.officeID = this.myOfficeID;
      this.addCoreVm.OfficeIDList = this.OfficeIDList;
      this.addCoreVm.Status = formValues.Status;
      this.addCoreVm.medicalCategoryID = Number(this.medicalCategoryID) > 0 ? Number(this.medicalCategoryID) : 0;
      this.loaderService.show();
      this.coreService.saveCoreUserDetails(this.addCoreVm).subscribe((response) => {
        if (response != undefined) {
          this.spinner = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.myFormGroup.markAsPristine();

            var obj1 = {
              transactionId: this.transactionID,
              name: formValues.Name,
              email: formValues.Email,
              FromModuleName: 'Core'
            }
            if (this.SendingFor == "SendTasklist") {
              this.selectedCoreIdForSendTaskListUpdate.emit(obj1);
            } else {
              this.SendtoSaved3C.emit(true);
              this._dataSharingService.sendRefreshListFromCore(true);
            }
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
            this.closeListingDetails();
          } else {
            this.spinner = false;
            this.loaderService.hide();
          }
        } else {
          this.spinner = false;
          this.loaderService.hide();
        }
      });
    }
  }


  saveContactDetails(formValues) {
    this.spinner = true;
    this.myFormGroup.markAsPristine();
    if (formValues !== undefined) {
      this.addContactVm.DatabaseID = Number(this.databaseId);
      this.addContactVm.UserID = this.currentUser.UID;
      this.addContactVm.ContactID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
      this.addContactVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }

        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
              var selectedValueChk = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();

            } else {
              selectedValues = '';
            }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');

              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          let ctrlsfi = this.arrayControlNameSubfolderID.find(e => e.name == key);
          let localDateOnly = "";

          if (tempList[0].fieldTypeName == 'Date') {
            let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;

            // If selectedDate is a string, set localDateOnly to the string value directly
            if (typeof selectedDate === "string") {
              localDateOnly = selectedDate;
            } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
              // Adjust the date to remove time and prevent timezone shift
              localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]; // Returns 'yyyy-MM-dd'
              formValues[key] = localDateOnly;
            } else {
              localDateOnly = ""; // Set to empty if no valid date
            }

          }
          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: ctrlsfi != undefined ? ctrlsfi.subfolderID : 0,
            ChildFields: [],
            id: frmctrl != undefined ? frmctrl.id : 0
          });
        }
      }



      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'City') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'City').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'State') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'State').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'ZipCode') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'ZipCode').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'Country') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'Country').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'City').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["City"],
      //   "childFieldType": 3
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'State').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["State"],
      //   "childFieldType": 2
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'ZipCode').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["ZipCode"],
      //   "childFieldType": 4
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'Country').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["Country"],
      //   "childFieldType": 1
      // })
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/

      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let cityctrl = this.arryaControlNameIdpare.find(e => e.name == 'City' + i);
        let statectrl = this.arryaControlNameIdpare.find(e => e.name == 'State' + i);
        let zipcodectrl = this.arryaControlNameIdpare.find(e => e.name == 'ZipCode' + i);
        let countryctrl = this.arryaControlNameIdpare.find(e => e.name == 'Country' + i);
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        AddressDynamic.ChildFields.push({
          "id": cityctrl != undefined ? cityctrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City" + i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": statectrl != undefined ? statectrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State" + i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": zipcodectrl != undefined ? zipcodectrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode" + i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": countryctrl != undefined ? countryctrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country" + i],
          "childFieldType": 1
        })
        fieldList = fieldList.filter(function (value, index) {
          return index != indexDynamic;
        });
        fieldList.splice(indexDynamic, 0, AddressDynamic);

      });
      //********** */
      fieldList = fieldList.filter((x:any) => x.FieldName != "Status");
      this.addContactVm.ImageUrl = this.ImagePathURL
      this.addContactVm.Fields = fieldList;
      this.addContactVm.TypeID = Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0;
      this.addContactVm.Tags = this.tagvalues;
      this.addContactVm.officeID = this.myOfficeID;
      this.addContactVm.OfficeIDList = this.OfficeIDList;
      this.addContactVm.Status = formValues.Status;
      this.loaderService.show();
      this.coreService.saveContactUserDetails(this.addContactVm).subscribe((response) => {
        if (response != undefined) {
          this.spinner = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.myFormGroup.markAsPristine();
            this.arryaControlNameIdpare = [];
            this.toastr.success('Record Update successfully.', '', {
              timeOut: 3000,
            });
            this.SendtoSaved3C.emit(true);
            this._dataSharingService.sendRefreshListFromCore(true);
          } else {
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      });
    }

  }


  saveCompanyDetails(formValues) {
    this.spinner = true;
    this.myFormGroup.markAsPristine();
    if (formValues !== undefined) {
      this.addCompanyVm.DatabaseID = Number(this.databaseId);
      this.addCompanyVm.UserID = this.currentUser.UID;
      this.addCompanyVm.CompanyID = this.transactionID;//Number(sessionStorage.getItem('transactionID'));
      this.addCompanyVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }

        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
              var selectedValueChk = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();

            } else {
              selectedValues = '';
            }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');

              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          let ctrlsfi = this.arrayControlNameSubfolderID.find(e => e.name == key);
          let localDateOnly = "";

          if (tempList[0].fieldTypeName == 'Date') {
            let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;

            // If selectedDate is a string, set localDateOnly to the string value directly
            if (typeof selectedDate === "string") {
              localDateOnly = selectedDate;
            } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
              // Adjust the date to remove time and prevent timezone shift
              localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]; // Returns 'yyyy-MM-dd'
              formValues[key] = localDateOnly;
            } else {
              localDateOnly = ""; // Set to empty if no valid date
            }

          }
          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: ctrlsfi != undefined ? ctrlsfi.subfolderID : 0,
            ChildFields: [],
            id: frmctrl != undefined ? frmctrl.id : 0
          });
        }
      }

      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'City') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'City').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'State') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'State').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'ZipCode') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'ZipCode').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name == 'Country') != undefined ? this.arryaControlNameIdpare.find(e => e.name == 'Country').id : 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'City').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["City"],
      //   "childFieldType": 3
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'State').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["State"],
      //   "childFieldType": 2
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'ZipCode').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["ZipCode"],
      //   "childFieldType": 4
      // })
      // AddressDefault.ChildFields.push({
      //   "id": this.arryaControlNameIdpare.find(e => e.name== 'Country').id,
      //   "fieldID": AddressDefault.FieldID,
      //   "fieldValue": formValues["Country"],
      //   "childFieldType": 1
      // })
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/

      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let cityctrl = this.arryaControlNameIdpare.find(e => e.name == 'City' + i);
        let statectrl = this.arryaControlNameIdpare.find(e => e.name == 'State' + i);
        let zipcodectrl = this.arryaControlNameIdpare.find(e => e.name == 'ZipCode' + i);
        let countryctrl = this.arryaControlNameIdpare.find(e => e.name == 'Country' + i);
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        AddressDynamic.ChildFields.push({
          "id": cityctrl != undefined ? cityctrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City" + i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": statectrl != undefined ? statectrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State" + i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": zipcodectrl != undefined ? zipcodectrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode" + i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": countryctrl != undefined ? countryctrl.id : 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country" + i],
          "childFieldType": 1
        })
        fieldList = fieldList.filter(function (value, index) {
          return index != indexDynamic;
        });
        fieldList.splice(indexDynamic, 0, AddressDynamic);

      });
      //********** */
      fieldList = fieldList.filter((x:any) => x.FieldName != "Status");
      this.addCompanyVm.ImageUrl = this.ImagePathURL
      this.addCompanyVm.Fields = fieldList;
      this.addCompanyVm.TypeID = Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0;
      this.addCompanyVm.Tags = this.tagvalues;
      this.addCompanyVm.officeID = this.myOfficeID;
      this.addCompanyVm.OfficeIDList = this.OfficeIDList;
      this.addCompanyVm.Status = formValues.Status;
      this.loaderService.show();
      this.coreService.saveCompanyUserDetails(this.addCompanyVm).subscribe((response) => {
        if (response != undefined) {
          this.spinner = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.myFormGroup.markAsPristine();
            this.arryaControlNameIdpare = [];
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
            this.SendtoSaved3C.emit(true);
            this._dataSharingService.sendRefreshListFromCore(true);
          } else {
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      });
    }

  }


  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow: Backspace, Tab, Delete, Left, Right arrows
    if ([8, 9, 46, 37, 39].includes(charCode)) {
      return true;
    }

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    // Allow decimal point (.)
    if (charCode === 46) {
      // Prevent more than one decimal point
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.includes('.')) {
        return false;
      }
      return true;
    }

    return false;
  }


  // numberOnly(event): boolean {
  //   const charCode = event.which ? event.which : event.keyCode;
  //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //     return false;
  //   }
  //   return true;
  // }   


  // getAllFoldersField(event) {
  //   if(this.modulenames== "Core"){
  //     if (event != undefined) {
  //       if (event.tab.textLabel == this.folderText) {
  //         this.getFieldModel.databaseID = Number(this.databaseId);
  //         this.getFieldModel.userID = this.currentUser.UID;
  //         this.getFieldModel.folderID = this.folderID;
  //         this.settingService.getFolderFields(this.getFieldModel).subscribe((response) => {
  //             if (response) {
  //               this.getFieldsListResponseHolder = response;
  //               if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
  //                 this.fieldsList = this.getFieldsListResponseHolder.data;  
  //                 this.fieldsList.forEach((element) => {
  //                   if (element.fieldTypeName == this.constant.TextArea) {
  //                     this.showTextBoxField = true;
  //                     this.showDropdownBoxField = false;
  //                     this.showCheckboxField = false;
  //                     this.inputTypeFieldAttribute.fieldText =
  //                       element.defaultValue;
  //                     this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
  //                     this.checkBoxFieldArray = [];
  //                     this.dropdownFieldArray = [];
  //                   } else if (
  //                     element.fieldTypeName == this.constant.DropDownField
  //                   ) {
  //                     this.showDropdownBoxField = true;
  //                     this.showTextBoxField = false;
  //                     this.showCheckboxField = false;
  //                     this.dropdownFieldAttribute.fieldText =
  //                       element.defaultValue;
  //                     this.dropdownFieldArray.push(this.dropdownFieldAttribute);
  //                     this.inputTypeFieldArray = [];
  //                     this.checkBoxFieldArray = [];
  //                   } else if (
  //                     element.fieldTypeName == this.constant.CheckboxField
  //                   ) {
  //                     this.showCheckboxField = true;
  //                     this.showDropdownBoxField = false;
  //                     this.showTextBoxField = false;
  //                     this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
  //                     this.inputTypeFieldArray = [];
  //                     this.dropdownFieldArray = [];
  //                   } else {
  //                   }
  //                 });
  //               } else {
  //                 this.loaderService.hide();
  //               }
  //             }
  //           });
  //       }
  //     }
  //   }

  //   if(this.modulenames == "Contact"){
  //     if (event != undefined) {
  //       if (event.tab.textLabel == this.folderText) {
  //         this.getFieldModel.databaseID = Number(this.databaseId);
  //         this.getFieldModel.userID = this.currentUser.UID;
  //         this.getFieldModel.folderID = this.folderID;//20;
  //         this.settingService.getFolderFields(this.getFieldModel).subscribe((response) => {
  //            if (response) {
  //               this.getFieldsListResponseHolder = response;
  //               if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
  //                 this.fieldsList = this.getFieldsListResponseHolder.data;  
  //                 this.fieldsList.forEach((element) => {
  //                   if (element.fieldTypeName == this.constant.TextArea) {
  //                     this.showTextBoxField = true;
  //                     this.showDropdownBoxField = false;
  //                     this.showCheckboxField = false;
  //                     this.inputTypeFieldAttribute.fieldText =
  //                       element.defaultValue;
  //                     this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
  //                     this.checkBoxFieldArray = [];
  //                     this.dropdownFieldArray = [];
  //                   } else if (
  //                     element.fieldTypeName == this.constant.DropDownField
  //                   ) {
  //                     this.showDropdownBoxField = true;
  //                     this.showTextBoxField = false;
  //                     this.showCheckboxField = false;
  //                     this.dropdownFieldAttribute.fieldText =
  //                       element.defaultValue;
  //                     this.dropdownFieldArray.push(this.dropdownFieldAttribute);
  //                     this.inputTypeFieldArray = [];
  //                     this.checkBoxFieldArray = [];
  //                   } else if (
  //                     element.fieldTypeName == this.constant.CheckboxField
  //                   ) {
  //                     this.showCheckboxField = true;
  //                     this.showDropdownBoxField = false;
  //                     this.showTextBoxField = false;
  //                     this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
  //                     this.inputTypeFieldArray = [];
  //                     this.dropdownFieldArray = [];
  //                   } else {
  //                   }
  //                 });
  //               } else {
  //                 this.loaderService.hide();
  //               }
  //             }
  //           });
  //       }
  //     }
  //   }

  //   if(this.modulenames == "Company"){
  //     if (event != undefined) {
  //       if (event.tab.textLabel == this.folderText) {
  //         this.getFieldModel.databaseID = Number(this.databaseId);
  //         this.getFieldModel.userID = this.currentUser.UID;
  //         this.getFieldModel.folderID = this.folderID;//19;
  //         this.settingService.getFolderFields(this.getFieldModel).subscribe((response) => {
  //             if (response) {
  //               this.getFieldsListResponseHolder = response;
  //               if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
  //                 this.fieldsList = this.getFieldsListResponseHolder.data;  
  //                 this.fieldsList.forEach((element) => {
  //                   if (element.fieldTypeName == this.constant.TextArea) {
  //                     this.showTextBoxField = true;
  //                     this.showDropdownBoxField = false;
  //                     this.showCheckboxField = false;
  //                     this.inputTypeFieldAttribute.fieldText =
  //                       element.defaultValue;
  //                     this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
  //                     this.checkBoxFieldArray = [];
  //                     this.dropdownFieldArray = [];
  //                   } else if (
  //                     element.fieldTypeName == this.constant.DropDownField
  //                   ) {
  //                     this.showDropdownBoxField = true;
  //                     this.showTextBoxField = false;
  //                     this.showCheckboxField = false;
  //                     this.dropdownFieldAttribute.fieldText =
  //                       element.defaultValue;
  //                     this.dropdownFieldArray.push(this.dropdownFieldAttribute);
  //                     this.inputTypeFieldArray = [];
  //                     this.checkBoxFieldArray = [];
  //                   } else if (
  //                     element.fieldTypeName == this.constant.CheckboxField
  //                   ) {
  //                     this.showCheckboxField = true;
  //                     this.showDropdownBoxField = false;
  //                     this.showTextBoxField = false;
  //                     this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
  //                     this.inputTypeFieldArray = [];
  //                     this.dropdownFieldArray = [];
  //                   } else {
  //                   }
  //                 });
  //               } else {
  //                 this.loaderService.hide();
  //               }
  //             }
  //           });
  //       }
  //     }
  //   }
  // }

  openInDocument() {
    if (this.modulenames == "Core") {
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', this.TypeIdDrp);
      sessionStorage.setItem('moduleName', 'Core');
      this.router.navigate(['/core/documents'], {});
      this._dataSharingService.sendSelectedModuleName('Core');
      this._dataSharingService.sendNextPreviousDocumentFromCore(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      this.closeListingDetails();
    }

    if (this.modulenames == "Contact") {
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', this.TypeIdDrp);
      sessionStorage.setItem('moduleName', 'Contact');
      this.router.navigate(['/contact/documents'], {});
      this._dataSharingService.sendSelectedModuleName('Contact');
      this._dataSharingService.sendNextPreviousDocumentFromContact(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
      this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      this.closeListingDetails();
    }

    if (this.modulenames == "Company") {
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', this.TypeIdDrp);
      sessionStorage.setItem('moduleName', 'Company');
      this.router.navigate(['/company/documents'], {});
      this._dataSharingService.sendSelectedModuleName('Company');
      this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
      this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
      this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
      this.closeListingDetails();
    }

  }

  openDocumentInNewTab() {
    if (this.modulenames == "Core") {
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', this.TypeIdDrp);
      sessionStorage.setItem('moduleName', 'Core');
      //this.router.navigate(['/core/documents'], {});  
      //this._dataSharingService.sendSelectedModuleName('Core');
      //this._dataSharingService.sendNextPreviousDocumentFromCore(false);
      //this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
      // this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
      window.open('/core/documents', '_blank');
      // this.closeListingDetails();
    }

    if (this.modulenames == "Contact") {
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', this.TypeIdDrp);
      sessionStorage.setItem('moduleName', 'Contact');
      //this.router.navigate(['/contact/documents'], {});    
      //this._dataSharingService.sendSelectedModuleName('Contact');
      //this._dataSharingService.sendNextPreviousDocumentFromContact(false);
      //this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
      //this._dataSharingService.sendNextPreviousForTouchesFromContact(false);
      window.open('/contact/documents', '_blank');
      //this.closeListingDetails();
    }

    if (this.modulenames == "Company") {
      const id = this.transactionID.toString();
      sessionStorage.setItem('transactionID', id);
      sessionStorage.setItem('TypeID', this.TypeIdDrp);
      sessionStorage.setItem('moduleName', 'Company');
      //this.router.navigate(['/company/documents'], {});
      //this._dataSharingService.sendSelectedModuleName('Company');
      //this._dataSharingService.sendNextPreviousDocumentFromCompany(false);
      //this._dataSharingService.sendNextPreviousForRightPanelFromCompany(false);
      //this._dataSharingService.sendNextPreviousForTouchesFromCompany(false);
      //this.closeListingDetails();
      window.open('/company/documents', '_blank');
    }

  }


  clearDate(field) {
    return field.fieldValue = "";
  }

  AllCoreTouchesList: any[] = [];
  AllContactTouchesList: any[] = [];
  AllCompanyTouchesList: any[] = [];
  textLabel: string = "";

  onTabClick(event) {
    this.textLabel = event.tab.textLabel;
    if (event.tab.textLabel == "Notes" || event.index == 1) {
       this.showActivityData();      
    }
  }


   showActivityData(){
      this.AllCoreTouchesList = [];
      this.AllContactTouchesList = [];
      this.AllCompanyTouchesList = [];
      if (this.modulenames == "Core") {
        this.getAllCoreTouchesList();
      }
      if (this.modulenames == "Contact") {
        this.getAllContactTouchesList();
      }
      if (this.modulenames == "Company") {
        this.getAllCompanyTouchesList();
      }
   }

  // get Core Activity List
  getAllCoreTouchesList() {
    var ReqModel = {
      folderID: this.folderID,
      transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
      documentID: null,
      databaseId: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
      userID: this.currentUser.UID
    }
    this.coreService.GetAllCoreTouches(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.getTagListResponseHolder = response.data;
          if (this.getTagListResponseHolder != null) {
            this.getTagListResponseHolder.map((res) => {
              if (res.createdByLastName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByLastName);
              }
              if (res.byPortal != null) {
                let toArray = res.byPortal.split("@");
                res.createdByFirstName = toArray[0];
              }
              if (res.touchNote != null) {
                res.touchNote1 = res.touchNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
                res.touchNoteNew = this.makeLinksClickable(res.touchNote1);
                // res.touchNoteNew = this.makeLinksClickable(res.touchNote);
              }
              return res;
            });
          }
          this.AllCoreTouchesList = this.getTagListResponseHolder;
        }
        else {
          this.AllCoreTouchesList = [];
        }
      }
    });
  }

  // get contact Activity List
  getAllContactTouchesList() {
    var ReqModel = {
      folderID: this.folderID,
      transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
      documentID: null,
      databaseId: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
      userID: this.currentUser.UID
    }
    this.coreService.GetAllContactTouches(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.getTagListResponseHolder = response.data;
          if (this.getTagListResponseHolder != null) {
            this.getTagListResponseHolder.map((res) => {
              if (res.createdByLastName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByLastName);
              }
              if (res.byPortal != null) {
                let toArray = res.byPortal.split("@");
                res.createdByFirstName = toArray[0];
              }
              if (res.touchNote != null) {
                res.touchNote1 = res.touchNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
                res.touchNoteNew = this.makeLinksClickable(res.touchNote1);
                // res.touchNoteNew = this.makeLinksClickable(res.touchNote);
              }
              return res;
            });
          }
         // this.AllContactTouchesList = this.getTagListResponseHolder;
          this.AllCoreTouchesList = this.getTagListResponseHolder;
        }
        else {

        }
      }
    });
  }

  // get company Activity List
  getAllCompanyTouchesList() {
    var ReqModel = {
      folderID: this.folderID,
      transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
      documentID: null,
      databaseId: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      OfficeIDList: this.OfficeIDList,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID
    }
    this.coreService.GetAllCompanyTouches(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.getTagListResponseHolder = response.data;
          if (this.getTagListResponseHolder != null) {
            this.getTagListResponseHolder.map((res) => {
              if (res.createdByLastName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByLastName);
              }
              if (res.byPortal != null) {
                let toArray = res.byPortal.split("@");
                res.createdByFirstName = toArray[0];
              }
              if (res.touchNote != null) {
                res.touchNote1 = res.touchNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
                res.touchNoteNew = this.makeLinksClickable(res.touchNote1);
                // res.touchNoteNew = this.makeLinksClickable(res.touchNote);
              }
              return res;
            });
          }
          //this.AllCompanyTouchesList = this.getTagListResponseHolder;
          this.AllCoreTouchesList = this.getTagListResponseHolder;
        }
        else {
        }
      }
    });
  }

  makeLinksClickable(text: string): SafeHtml {
    if (!text) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Replace URLs with anchor tags
    const modifiedText = text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

    // Sanitize the resulting HTML
    return this.sanitizer.bypassSecurityTrustHtml(modifiedText);
  }

  addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {
      data: {
        moduleName: this.modulenames,
        folderID: 1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        transactionID: this.transactionID
      },
      panelClass: 'autoFill-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        if (this.modulenames == "Core") {
          this.getAllCoreTouchesList();
        }
        if (this.modulenames == "Contact") {
          this.getAllContactTouchesList();
        }
        if (this.modulenames == "Company") {
          this.getAllCompanyTouchesList();
        }

      }
    });
  }

  editTouch(touch: any) {
    const dialogRef = this.dialog.open(AddTouchesComponent, {
      data: {
        moduleName: this.modulenames,
        folderID: 1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        touch: touch,
        transactionID: this.transactionID
      },
      panelClass: 'autoFill-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        if (this.modulenames == "Core") {
          this.getAllCoreTouchesList();
        }
        if (this.modulenames == "Contact") {
          this.getAllContactTouchesList();
        }
        if (this.modulenames == "Company") {
          this.getAllCompanyTouchesList();
        }
      }
    });
  }


  deleteTouch(touch: any) {
   if (this.modulenames == "Core") {
    const message = `Are you sure you want to delete this Note ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let model = {
            "touchesID": [
              touch.touchID
            ],
            transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
            databaseId: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            userID: this.currentUser.UID,
            officeID: this.myOfficeID
          }
          this.coreService.DeleteCoreTouch(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.toastr.success("Record Deleted successfully.", '', {
                  timeOut: 3000,
                });
                if (this.modulenames == "Core") {
                  this.getAllCoreTouchesList();
                }
                if (this.modulenames == "Contact") {
                  this.getAllContactTouchesList();
                }
                if (this.modulenames == "Company") {
                  this.getAllCompanyTouchesList();
                }
              }
              else {

              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
   }

    if (this.modulenames == "Contact") {
    const message = `Are you sure you want to delete this Note ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let model = {
            "touchesID": [
              touch.touchID
            ],
            transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
            databaseId: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            userID: this.currentUser.UID,
            officeID: this.myOfficeID
          }
          this.coreService.DeleteContactTouch(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.toastr.success("Record Deleted successfully.", '', {
                  timeOut: 3000,
                });
                if (this.modulenames == "Core") {
                  this.getAllCoreTouchesList();
                }
                if (this.modulenames == "Contact") {
                  this.getAllContactTouchesList();
                }
                if (this.modulenames == "Company") {
                  this.getAllCompanyTouchesList();
                }
              }
              else {

              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
   }

   if (this.modulenames == "Company") {
    const message = `Are you sure you want to delete this Note ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let model = {
            "touchesID": [
              touch.touchID
            ],
            transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
            databaseId: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            userID: this.currentUser.UID,
            officeID: this.myOfficeID
          }
          this.coreService.DeleteCompanyTouch(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.toastr.success("Record Deleted successfully.", '', {
                  timeOut: 3000,
                });
                if (this.modulenames == "Core") {
                  this.getAllCoreTouchesList();
                }
                if (this.modulenames == "Contact") {
                  this.getAllContactTouchesList();
                }
                if (this.modulenames == "Company") {
                  this.getAllCompanyTouchesList();
                }
              }
              else {

              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
   }
}


  getPDPMStagesList: any[] = [];
  medicalCategoryID: number = 0;
  coreProcessStages: any[] = [];

  //=========For Change Medical Category =======//

  selectStage(stageId: number) {
    this.medicalCategoryID = stageId;
    if (this.coreProcessStages.length > 0) {
      var checks: any = [] = [];
      checks = this.coreProcessStages.filter((x:any) => x.processStageID == Number(stageId));
      if (checks.length > 0) {
       // this.changeStage();
        this.ChangeMedicalCategoryForCoreNew();
        return;
      }else{
        this.ChangeMedicalCategoryForCore(true);
      }
    } else {
      this.ChangeMedicalCategoryForCore(true);
    }
  }

  ChangeMedicalCategoryForCore(isOverwrite:any) {
    var ReqModel = {
      processStageID: Number(this.medicalCategoryID),
      isOverwrite: isOverwrite,
      coreID: Number(this.transactionID),
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.coreService.changeMedicalCategoryForCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('pdpm category updated successfully.', '', {
            timeOut: 3000,
          });
          this.getCoreUserDetails();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

   ChangeMedicalCategoryForCoreNew() {
    var ReqModel = {
      processStageID: Number(this.medicalCategoryID),
      isOverwrite: false,
      coreID: Number(this.transactionID),
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.coreService.changeMedicalCategoryForCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('pdpm category updated successfully.', '', {
            timeOut: 3000,
          });
          this.getCoreUserDetails();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  changeStage() {
    const message = `Are you sure you want to move to this pdpm category? This person was already in this pdpm category earlier.`;
    const title = `Confirm move`;
    const confirm = `Move`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogChangeComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var isOverwrite = false;
          if (dialogResult == "WithoutFolder") {
            isOverwrite = false;
          }
          if (dialogResult == "CreateNewFolder") {
            isOverwrite = true;
          }
          this.ChangeMedicalCategoryForCore(isOverwrite);
          // this.SaveCoreUserDetails(this.myFormGroup.value);
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  getPDPMStageslist() {
    var ReqModel = {
      categoryID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getPDPMStage(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.getPDPMStagesList = response.data;
        } else {
          this.getPDPMStagesList = [];
        }
      } else {
        this.getPDPMStagesList = [];
      }
    });
  }

  //=========For Change Process Stage =======//

  selectProcessStageOnChange(event: any, fieldName: any) {
    this.ProcessStageIdDrp = parseInt(event.value);
    if (this.stages.length > 0) {
      var checks: any = [] = [];
      checks = this.stages.filter((x:any) => x.processStageID == Number(this.ProcessStageIdDrp));
      if (checks.length > 0) {
        this.changeProcessStage();
        return;
      }else{
        this.changeProcessStageForCore(true);
      }
    }
    this.changeProcessStageForCore(true);
  }

  changeProcessStageForCore(isOverwrite:any) {
    var ReqModel = {
      processStageID: Number(this.ProcessStageIdDrp),
      isOverwrite: isOverwrite,
      coreID: Number(this.transactionID),
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.coreService.changeProcessStageForCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.getCoreUserDetails();
          this.toastr.success('Process stage status updated successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  changeProcessStage() {
    const message = `Are you sure you want to move to this stage? This person was already in this stage earlier, and moving again will regenerate all documents and forms.`;
    const title = `Confirm move`;
    const confirm = `Move`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogChangeComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var isOverwrite = false;
          if (dialogResult == "WithoutFolder") {
            isOverwrite = false;
          }
          if (dialogResult == "CreateNewFolder") {
            isOverwrite = true;
          }
          this.changeProcessStageForCore(isOverwrite);
          //this.SaveCoreUserDetails(this.myFormGroup.value);
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  thirdPartyApplicationList: any = [] = [];

  getThirdPartyApplicationList() {
    this.loaderService.show();
    var ReqModel = {
      isOffice: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.settingsService.getThirdPartyApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data;
          if (this.thirdPartyApplicationList.length > 0) {
            var Paycheck = [];
            var PointClickCare = [];

            Paycheck = this.thirdPartyApplicationList.filter((x:any) => x.thirdPartyApiName.toLowerCase() == "Paychex".toLowerCase());
            PointClickCare = this.thirdPartyApplicationList.filter((x:any) => x.thirdPartyApiName.toLowerCase() == "PointClickCare".toLowerCase());

            if (Paycheck.length > 0) {
              if (Paycheck[0].apiAuthDetail != null) {
                if (Paycheck[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('Paycheck', 'true');
                }
              }
            }
            if (PointClickCare.length > 0) {
              if (PointClickCare[0].apiAuthDetail != null) {
                if (PointClickCare[0].apiAuthDetail.isRequestclientAccessed == true) {
                  sessionStorage.setItem('PointClickCare', 'true');
                }
              }
            }
          }
        }
        else {
          this.thirdPartyApplicationList = [];
        }
      }
      else {
        this.thirdPartyApplicationList = [];
      }
    });
  }

   payChekSubmittedResult: any;
   isReCreate: boolean = false;
   paycheckErrorList: any = [] = [];
   associatedAPIs: any = [] = [];
   showPCC: boolean = false;
   pccToolTip: string = "Send to PointClickCare";
   transactionIDForTask: number = 0;  
   paychexID: any;
   ShowPointClickCare: boolean = false;
  
   SendtoPendingPatientPCC() {
       //== For Core====//
   
       this.associatedAPIs = JSON.parse(sessionStorage.getItem('associatedAPIs') || '[]');
       if (this.associatedAPIs.length > 0) {
         var checkPCC = [];
         checkPCC = this.associatedAPIs.filter((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
         if (checkPCC.length > 0) {
           this.showPCC = true;
         } else {
           this.showPCC = false;
         }
       }
       // if (this.typeId == undefined) {
       //   this.typeId = 0;
       // }
   
       this.payChekSubmittedResult = [];
       var result: any = [] = [];
       var objs = {
         name: this.transactionUserName,
         coreID: Number(this.transactionID),
         subFolderID: this.TypeIdDrp
       }
       result.push(objs);
   
       this.payChekSubmittedResult = result;
       this.paycheckErrorList = [];
       if (result.length > 0 && result != "" && result != undefined) {
   
         var coreListForPaychex = [];
         var thirdPartyApiID = 0;
         var officeThirdPartyApiID = 0;
   
         if (this.associatedAPIs.find((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
           thirdPartyApiID = this.associatedAPIs.find((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
           officeThirdPartyApiID = this.associatedAPIs.find((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
         }
   
         for (let i = 0; i < result.length; i++) {
           var obj = {
             coreID: result[i].coreID,
             subFolderID: result[i].subFolderID,
           }
           coreListForPaychex.push(obj);
         }
         var ReqModel = {
           coreList: coreListForPaychex,
           folderID: this.folderID,
           thirdPartyApiID: thirdPartyApiID,
           officeThirdPartyApiID: officeThirdPartyApiID,
           userID: this.currentUser.UID,
           organizationID: Number(this.organizationId),
           officeID: this.myOfficeID,
           isrecreate: this.isReCreate
         }
         //return;  
         this.loaderService.show();
         this.coreService.sendToPendingPatientPCC(ReqModel).subscribe((response) => {
           if (response != undefined) {
             this.isReCreate = false;
             this.responseHolder = response;
             if (this.responseHolder.status == this.statusConst.statusSuccess) {
               this.loaderService.hide();
               var check: any = [];
               var checkError :any= [];
               check = this.responseHolder.data;
               check = check.pccResponses;
   
               let quotaExusted: any;
               let quotaExustedMessage = "";
               if (check.length > 0) {
                 checkError = check.filter((x:any) => x.errors != null);
                 checkError.forEach((ne:any) => {
                   ne.errors.forEach((ee:any) => {
                     if (ee.code == '100') {
                       quotaExusted = ee.code;
                       quotaExustedMessage = ee.detail;
                       var obj = {
                         name: "Temporary API Service Unavailability",
                         code: "API will start functioning at " + new Date(ee.xQuotaTimeToResetDateTime),
                         description: ee.detail,
                       }
                       this.paycheckErrorList.push(obj);
                       this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                     }
                   });
                   ne.errors = ne.errors.filter((m:any) => m.type == 0);
                 });
                 if (quotaExusted == '100') {
                   return;
                 }
                 checkError = checkError.filter((x:any) => x.errors.length != 0);
                 if (checkError.length == 0) {
                   this.getCoreUserDetailsAfterSendPCC();
                   this.toastr.success('Record added in Pending Patient successfully.', '', {
                     timeOut: 3000,
                   });
                 } else {
   
                   for (var i = 0, len = checkError.length; i < len; ++i) {
   
                     let list = [];
                     let name = "";
                     list = result.filter((x:any) => x.coreID == Number(checkError[i].coreID));
                     if (list.length > 0) {
                       name = list[0].name;
                     }
                     if (checkError[i].errors != null) {
                       checkError[i].errors.forEach((eelement:any) => {
   
                         var obj = {
                           name: name,
                           code: eelement.code,
                           description: eelement.detail,
                         }
                         this.paycheckErrorList.push(obj);
                       });
                     }
                   }
   
                   const hasVendorAccessError = this.paycheckErrorList.some((item:any) =>
                     item.description?.toLowerCase().includes("vendor does not have access") ?? false
                   );
   
                   // if (hasVendorAccessError == true) {
                   //   var obj = {
                   //     name: this.paycheckErrorList[0].name,
                   //     code: this.paycheckErrorList[0].code,
                   //     description: "Our system attempted to update a record in PointClickCare, but the update couldn't be completed because the record was locked in PointClickCare, Please manually update the record by logging directly into your PointClickCare account.",
                   //   }
                   //   this.paycheckErrorList = [];
                   //   this.paycheckErrorList.push(obj);
                   //   this.showPaycheckError("PointClickCare record locked, manual update is needed");
                   // }
                   // else
                   this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                 }
               }
             }
           } else {
             this.loaderService.hide();
           }
         });
       }
     }

    // SendtoPendingPatientPCC() {
    //   //== For Core====//
  
    //   this.associatedAPIs = JSON.parse(sessionStorage.getItem('associatedAPIs') || '[]');
    //   if (this.associatedAPIs.length > 0) {
    //     var checkPCC = [];
    //     checkPCC = this.associatedAPIs.filter((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
    //     if (checkPCC.length > 0) {
    //       this.showPCC = true;
    //     } else {
    //       this.showPCC = false;
    //     }
    //   }
    //   // if (this.typeId == undefined) {
    //   //   this.typeId = 0;
    //   // }
  
    //   this.payChekSubmittedResult = [];
    //   var result: any = [] = [];
    //   var objs = {
    //     name: this.transactionUserName,
    //     coreID: Number(this.transactionID),
    //     subFolderID: this.TypeIdDrp
    //   }
    //   result.push(objs);
  
    //   this.payChekSubmittedResult = result;
    //   this.paycheckErrorList = [];
    //   if (result.length > 0 && result != "" && result != undefined) {
  
    //     var coreListForPaychex = [];
    //     var thirdPartyApiID = 0;
    //     var officeThirdPartyApiID = 0;
  
    //     if (this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
    //       thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
    //       officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
    //     }
  
    //     for (let i = 0; i < result.length; i++) {
    //       var obj = {
    //         coreID: result[i].coreID,
    //         subFolderID: result[i].subFolderID,
    //       }
    //       coreListForPaychex.push(obj);
    //     }
    //     var ReqModel = {
    //       coreList: coreListForPaychex,
    //       folderID: this.folderID,
    //       thirdPartyApiID: thirdPartyApiID,
    //       officeThirdPartyApiID: officeThirdPartyApiID,
    //       userID: this.currentUser.UID,
    //       organizationID: Number(this.organizationId),
    //       officeID: this.myOfficeID,
    //       isrecreate: this.isReCreate
    //     }
    //     //return;  
    //     this.loaderService.show();
    //     this.coreService.sendToPendingPatientPCC(ReqModel).subscribe((response) => {
    //       if (response != undefined) {
    //         this.isReCreate = false;
    //         this.responseHolder = response;
    //         if (this.responseHolder.status == this.statusConst.statusSuccess) {
    //           this.loaderService.hide();
    //           var check: any = [];
    //           var checkError = [];
    //           check = this.responseHolder.data;
    //           check = check.pccResponses;
  
    //           let quotaExusted: any;
    //           let quotaExustedMessage = "";
    //           if (check.length > 0) {
    //             checkError = check.filter((x:any) => x.errors != null);
    //             checkError.forEach(ne => {
    //               ne.errors.forEach(ee => {
    //                 if (ee.code == '100') {
    //                   quotaExusted = ee.code;
    //                   quotaExustedMessage = ee.detail;
    //                   var obj = {
    //                     name: "Temporary API Service Unavailability",
    //                     code: "API will start functioning at " + new Date(ee.xQuotaTimeToResetDateTime),
    //                     description: ee.detail,
    //                   }
    //                   this.paycheckErrorList.push(obj);
    //                   this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
    //                 }
    //               });
    //               ne.errors = ne.errors.filter(m => m.type == 0);
    //             });
    //             if (quotaExusted == '100') {
    //               return;
    //             }
    //             checkError = checkError.filter((x:any) => x.errors.length != 0);
    //             if (checkError.length == 0) {
    //               this.getCoreUserDetailsAfterSendPCC();
    //               this.toastr.success('Record added in Pending Patient successfully.', '', {
    //                 timeOut: 3000,
    //               });
    //             } else {
  
    //               for (var i = 0, len = checkError.length; i < len; ++i) {
  
    //                 let list = [];
    //                 let name = "";
    //                 list = result.filter((x:any) => x.coreID == Number(checkError[i].coreID));
    //                 if (list.length > 0) {
    //                   name = list[0].name;
    //                 }
    //                 if (checkError[i].errors != null) {
    //                   checkError[i].errors.forEach(eelement => {
  
    //                     var obj = {
    //                       name: name,
    //                       code: eelement.code,
    //                       description: eelement.detail,
    //                     }
    //                     this.paycheckErrorList.push(obj);
    //                   });
    //                 }
    //               }
  
    //               const hasVendorAccessError = this.paycheckErrorList.some(item =>
    //                 item.description?.toLowerCase().includes("vendor does not have access") ?? false
    //               );
  
    //               // if (hasVendorAccessError == true) {
    //               //   var obj = {
    //               //     name: this.paycheckErrorList[0].name,
    //               //     code: this.paycheckErrorList[0].code,
    //               //     description: "Our system attempted to update a record in PointClickCare, but the update couldn't be completed because the record was locked in PointClickCare, Please manually update the record by logging directly into your PointClickCare account.",
    //               //   }
    //               //   this.paycheckErrorList = [];
    //               //   this.paycheckErrorList.push(obj);
    //               //   this.showPaycheckError("PointClickCare record locked, manual update is needed");
    //               // }
    //               // else
    //                 this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
    //             }
    //           }
    //         }
    //       } else {
    //         this.loaderService.hide();
    //       }
    //     });
    //   }
    // }
  
  
    showPaycheckError(title: any = null) {
      const dialogRef = this.dialog.open(PaycheckErrorComponent, {
        data: {
          list: this.paycheckErrorList,
          title: title,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isReCreate = result;
          this.SendtoPaychexRecordForCore(this.payChekSubmittedResult);
        }
      });
    }
  
    SendtoPaychexRecordForCore(result:any) {
      this.payChekSubmittedResult = result;
      this.paycheckErrorList = [];
      if (result.length > 0 && result != "" && result != undefined) {
  
        var coreListForPaychex = [];
        var thirdPartyApiID = 0;
        var officeThirdPartyApiID = 0;
  
        if (this.associatedAPIs.find((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true)) {
          thirdPartyApiID = this.associatedAPIs.find((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true).thirdPartyApiID;
          officeThirdPartyApiID = this.associatedAPIs.find((x:any) => x.apiName == 'Paychex' && x.isCoreMapped == true).officeThirdPartyApiID;
        }
  
        for (let i = 0; i < result.length; i++) {
          var obj = {
            coreID: result[i].selectedRecord,
            subFolderID: result[i].subFolderID,
          }
          coreListForPaychex.push(obj);
        }
        var ReqModel = {
          coreList: coreListForPaychex,
          folderID: this.folderID,
          thirdPartyApiID: thirdPartyApiID,
          officeThirdPartyApiID: officeThirdPartyApiID,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID: this.myOfficeID,
          isrecreate: this.isReCreate
        }
        //return;  
        this.loaderService.show();
        this.coreService.sendToPaychex(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.isReCreate = false;
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              var check : any= [];
              var checkError:any= [];
              check = this.responseHolder.data.response;
              if (check.length > 0) {
                checkError = check.filter((x:any) => x.status != this.statusConst.statusSuccess);
                if (checkError.length == 0) {
                  this.getCoreUserDetailsAfterSendPCC();
                  this.toastr.success('Record added in Paychex successfully.', '', {
                    timeOut: 3000,
                  });
                } else {
                  let list = [];
                  let name = "";
                  list = result.filter((x:any) => x.selectedRecord == Number(checkError[0].data.content[0].employeeId));
                  if (list.length > 0) {
                    name = list[0].name;
                  }
                  for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {
                    var obj = {
                      name: name,
                      code: checkError[0].data.errors[i].code,
                      description: checkError[0].data.errors[i].description,
                    }
                    this.paycheckErrorList.push(obj);
                  }
                  this.showPaycheckError();
                }
              }
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    }
  
    getCoreUserDetailsAfterSendPCC() {
      let thirdPartyApiID = 0;
      let officeThirdPartyApiID = 0;
  
      this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs")|| '[]');
      if (this.associatedAPIs && this.associatedAPIs.find((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find((x:any) => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
      }
  
      this.transactionIDForTask = Number(this.transactionID);//Number(sessionStorage.getItem('transactionID'));
      this.coreVm.DatabaseID = Number(this.databaseId);
      this.coreVm.OrganizationID = Number(this.organizationId);
      this.coreVm.coreID = Number(this.transactionID); //Number(sessionStorage.getItem('transactionID'));
      this.coreVm.FolderId = Number(this.folderID);
      this.coreVm.subFolderID = Number(this.TypeIdDrp);
      this.coreVm.UserID = this.currentUser.UID;
      this.coreVm.officeID = this.myOfficeID;
      this.coreVm.OfficeIDList = this.OfficeIDList;
      this.coreVm.thirdPartyApiID = thirdPartyApiID;
      this.coreVm.officeThirdPartyApiID = officeThirdPartyApiID;
      this.loaderService.show();
      this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            sessionStorage.setItem("PCCPatientID", response.data.patientId);
            sessionStorage.setItem("PCCPendingPatientID", response.data.pendingPatientId);
            this.pendingPatientId = response.data.pendingPatientId;
  
            if (this.pendingPatientId == null) {
              this.pccToolTip = "Send to PointClickCare";
            } else {
              this.pccToolTip = "Update to PointClickCare";
            }
  
            if (this.responseHolder.data.paychexID == null || this.responseHolder.data.paychexID == "" || this.responseHolder.data.paychexID == undefined) {
              this.showPaycheck = false;
            } else {
              this.paychexID = this.responseHolder.data.paychexID
              this.showPaycheck = true;
            }
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  
    getPaychexWorkerCommunication() {
      let thirdPartyApiID = 0;
      let officeThirdPartyApiID = 0;
  
      this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs")|| '[]');
      if (this.associatedAPIs && this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true).officeThirdPartyApiID;
      }
      var ReqModel = {
        FolderID: this.folderID,
        coreID: this.transactionID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
      }
      this.loaderService.show();
      this.coreService.getPaychexWorkerCommunication(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Synced with Paychex successfully.', '', {
              timeOut: 3000,
            });
            this.getCoreUserDetails();
  
            // if (this.associateCoreChild) {
            //     this.associateCoreChild.getNormalAndSharedContacts();
            //   // or call any other method you define in the child
            //  }
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }

}
